import { CustomGridStackWidget } from './grid-widget-config.service';

export interface GridTemplate {
  key: string;
  label: string;
  icon: string;
  description: string;
  layout: Partial<CustomGridStackWidget>[];
}

export const GRID_TEMPLATES: GridTemplate[] = [
  {
    key: 'standard',
    label: 'Standardvorlage',
    icon: 'fas fa-table-cells',
    description:
      'Karte, Kennzahl, Balken, Zeitverlauf und Tabelle - der klassische Rundumblick.',
    layout: [
      { id: 1, _id: 1, w: 8, h: 4, x: 0, y: 0, type: 'map' },
      { id: 12, _id: 12, w: 4, h: 2, x: 8, y: 0, type: 'info' },
      { id: 2, _id: 2, w: 4, h: 2, x: 8, y: 2, type: 'bar' },
      { id: 3, _id: 3, w: 8, h: 2, x: 0, y: 4, type: 'line' },
      { id: 4, _id: 4, w: 4, h: 2, x: 8, y: 4, type: 'table' },
    ],
  },
  {
    key: 'kartenfokus',
    label: 'Kartenfokus',
    icon: 'fas fa-map-location-dot',
    description:
      'Große Karte mit einer Kennzahl daneben - für die räumliche Analyse.',
    layout: [
      { id: 1, _id: 1, w: 8, h: 6, x: 0, y: 0, type: 'map' },
      { id: 2, _id: 2, w: 4, h: 6, x: 8, y: 0, type: 'info' },
    ],
  },
  {
    key: 'vergleich',
    label: 'Vergleich',
    icon: 'fas fa-chart-column',
    description:
      'Zwei Balkendiagramme nebeneinander plus Tabelle - zum direkten Gegenüberstellen.',
    layout: [
      { id: 1, _id: 1, w: 6, h: 4, x: 0, y: 0, type: 'bar' },
      { id: 2, _id: 2, w: 6, h: 4, x: 6, y: 0, type: 'bar' },
      { id: 3, _id: 3, w: 12, h: 2, x: 0, y: 4, type: 'table' },
    ],
  },
  {
    key: 'zeitverlauf',
    label: 'Zeitverlauf',
    icon: 'fas fa-chart-line',
    description:
      'Große Zeitreihe mit Tabelle darunter - für Entwicklungen über die Zeit.',
    layout: [
      { id: 1, _id: 1, w: 12, h: 4, x: 0, y: 0, type: 'line' },
      { id: 2, _id: 2, w: 12, h: 2, x: 0, y: 4, type: 'table' },
    ],
  },
  {
    key: 'kompakt',
    label: 'Kompakt',
    icon: 'fas fa-table-cells-large',
    description:
      'Kennzahl, Balken, Zeitverlauf und Tabelle im 2x2-Raster - ein schneller Datenüberblick ohne Karte.',
    layout: [
      { id: 1, _id: 1, w: 6, h: 3, x: 0, y: 0, type: 'info' },
      { id: 2, _id: 2, w: 6, h: 3, x: 6, y: 0, type: 'bar' },
      { id: 3, _id: 3, w: 6, h: 3, x: 0, y: 3, type: 'line' },
      { id: 4, _id: 4, w: 6, h: 3, x: 6, y: 3, type: 'table' },
    ],
  },
];
